import { API_BASE } from './api/http.js';

const INVITE_KEY = 'secretario.convite';

/** Endereço público do Secretário (no app instalado, o do servidor; no site, o próprio). */
export function siteOrigin(): string {
  const configured = import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined;
  if (configured) return configured.replace(/\/+$/, '');
  // No servidor de testes, os links já saem com o endereço público.
  if (window.location.hostname === 'sec-inc.vps-kinghost.net') return 'https://app.secretarios.net';
  try {
    if (/^https?:/.test(API_BASE)) return new URL(API_BASE).origin;
  } catch {
    /* cai no endereço da página */
  }
  return window.location.origin;
}

/** Link de convite: quem abrir e criar a conta já cai numa conversa com quem convidou. */
export function inviteLink(username: string): string {
  return `${siteOrigin()}/?convite=${encodeURIComponent(username)}`;
}

export function inviteText(username: string): string {
  return `Estou usando o Secretário pra conversar com proteção de ponta a ponta. Entra também e me chama: @${username}`;
}

/** Guarda quem convidou (lido do link ao abrir o site). */
export function rememberInviteFromUrl(): void {
  try {
    const invited = new URLSearchParams(window.location.search).get('convite');
    if (invited && /^[a-z0-9][a-z0-9._]{1,30}[a-z0-9]$/i.test(invited)) {
      window.localStorage.setItem(INVITE_KEY, invited.toLowerCase());
    }
  } catch {
    /* sem armazenamento: o convite vira só um link para o site */
  }
}

const RETURN_KEY = 'secretario.voltar';

/** Página pública que pediu conta (clínica): depois do código, o app volta para ela. */
export function rememberReturnPath(path: string): void {
  try {
    if (path.startsWith('/')) window.localStorage.setItem(RETURN_KEY, path);
  } catch {
    /* sem armazenamento: a pessoa reabre o link */
  }
}

export function takeReturnPath(): string | null {
  try {
    const path = window.localStorage.getItem(RETURN_KEY);
    if (path) window.localStorage.removeItem(RETURN_KEY);
    return path && path.startsWith('/') ? path : null;
  } catch {
    return null;
  }
}

/** Devolve quem convidou, uma única vez. */
export function takeInvite(): string | null {
  try {
    const invited = window.localStorage.getItem(INVITE_KEY);
    if (invited) window.localStorage.removeItem(INVITE_KEY);
    return invited;
  } catch {
    return null;
  }
}
